import React from "react";
import { motion } from "framer-motion";
import { Droplets, Timer, Toilet, Bug } from "lucide-react";
import { MASCOT_IMG, STYLE_REF_2 } from "../../data/constants";

const FACTS = [
  { icon: Bug, title: "IT'S A PARASITE", text: "Cyclospora cayetanensis. A single-celled freeloader you catch from unwashed produce. It lives in you rent-free." },
  { icon: Timer, title: "SLEEPER AGENT", text: "Incubates ~7 days, then activates. You'll be fine at brunch and radioactive by dinner." },
  { icon: Droplets, title: "WATERY DOOM", text: "Frequent, explosive, watery diarrhea. Cramps. Bloating. The full symphony. Encore performances guaranteed." },
  { icon: Toilet, title: "NO CHILL", text: "Symptoms can relapse for weeks. Your toilet becomes your best friend and worst enemy." },
];

export const LoreSection = () => {
  return (
    <section id="lore" className="relative px-4 py-16 md:py-24 max-w-6xl mx-auto" data-testid="lore-section">
      <div className="flex flex-col md:flex-row items-center gap-8 mb-12">
        <motion.img
          src={MASCOT_IMG}
          alt="Cyclospora mascot"
          className="w-28 md:w-40 wobble"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        />
        <div className="text-center md:text-left">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="stencil text-4xl md:text-6xl"
          >
            THE LORE
          </motion.h2>
        </div>
      </div>

      <div
        className="petri p-6 md:p-10 mb-10 relative overflow-hidden"
        style={{ backgroundImage: `linear-gradient(rgba(10,19,63,0.7), rgba(10,19,63,0.7)), url(${STYLE_REF_2})`, backgroundSize: "cover", backgroundBlendMode: "overlay" }}
        data-testid="lore-quote"
      >
        <p className="stencil-pink text-3xl md:text-5xl text-center leading-tight">
          "the disease that causes explosive diarrhea."
        </p>
        <p className="font-mono2 text-center text-white/60 mt-4 text-sm">— that's literally the whole meme. that's it. that's the coin.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {FACTS.map((f, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            whileHover={{ y: -8, rotate: i % 2 ? 2 : -2 }}
            className="petri p-5 flex flex-col gap-3"
            data-testid={`lore-fact-${i}`}
          >
            <f.icon className="text-[#b026ff]" size={32} />
            <h3 className="stencil text-xl">{f.title}</h3>
            <p className="font-mono2 text-xs text-white/70 leading-relaxed">{f.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default LoreSection;
